import { Form as FormAnt, ModalProps } from "antd";
import { Modal } from '@hdi-seguros/web-components.modal';
import { InsurancePolicy } from "../../../../../shared/interfaces";
import { FC, useState } from "react";
import { ColSize, RowSize, Form, InputForm, DraggerUploadFile } from "../../../../../shared/components";
import { displayErrorMessage, displaySuccessMessage } from "../../../../../shared/utils";
import { UploadFile, UploadProps } from "antd/lib";
import { UploadChangeParam } from "antd/es/upload";
import { fileToBase64DataUrl } from "../../../../../shared/utils/fillToBase64";
import EmailService, { buildSendMailRequest } from "../../../../../shared/services/email";
import { AttachedFile } from "../../../../../shared/interfaces/services/files";
import { DistributionListKey, Recipients, RecipientsType } from "../../../../../shared/interfaces/services/email-services";

interface RenewAPModalProps extends ModalProps {
    insurancePolicy?: InsurancePolicy;
    onClose: () => void;
    onUpdate: () => void;
}

export const RenewAPModal: FC<RenewAPModalProps> = ({ open, title, onClose, onUpdate, insurancePolicy }) => {

    const [loading, setLoading] = useState(false);
    const [form] = FormAnt.useForm();
    const [fileSelectUpload, setFileSelectUpload] = useState<AttachedFile[]>([]);
    const [documentTypeSelect] = useState<DocumentType | null>(null);

    const onSubmit = async () => {
        try {
            setLoading(true);
            const selectedFile = fileSelectUpload[0];
            const hasFileSelected = Boolean(fileSelectUpload[0]);
            await invokeSendEmail( hasFileSelected ? selectedFile : undefined, DistributionListKey.AP_RENEW, hasFileSelected);
            
        } catch (error) {
            displayErrorMessage('¡Ocurrió un error al solicitar la renovación!');
        } finally {
            setLoading(false);
            onClose();
            onUpdate();
        }
    };

      const invokeSendEmail = async (file: AttachedFile | undefined, distributionListKey: string, includeAttachments: boolean, additionalRecipients?: Recipients[]) => {
          const basePayload = {
            subject: `Renovación Web: Póliza ${String(insurancePolicy?.nroPoliza)} - ${insurancePolicy?.descripcionRama}`,
            body: form.getFieldValue('messageRenew') ?? '',
            includeAttachments,
            saveToSentItems: true,
          };

          const attachmentPayload = includeAttachments
          ? {
              attachmentBase64: file!.base,
              attachmentName: file!.name,
              attachmentMimeType: file!.mediaType,
            }
          : {};

          const payload = await buildSendMailRequest(
            {
              ...basePayload,
              ...attachmentPayload,
            },
            distributionListKey,
            additionalRecipients
          );
    
          if (payload) {
            try {
                await EmailService.sendMailViaLambda(payload);
                displaySuccessMessage(`Renovación de Póliza ${String(insurancePolicy?.nroPoliza)} (${insurancePolicy?.descripcionRama}) solicitada con éxito.`);
            } catch (error) {    
                displayErrorMessage(`Renovación de Póliza ${String(insurancePolicy?.nroPoliza)} (${insurancePolicy?.descripcionRama}) no pudo ser solicitada.`); 
            }            
          } else {
            displayErrorMessage(`Renovación de Póliza ${String(insurancePolicy?.nroPoliza)} (${insurancePolicy?.descripcionRama}) no pudo ser solicitada.`); 
          }
          
      } 

    const MAX_FILE_SIZE = 2 * 1024 * 1024;

    const handleFileSelection = async (info: UploadChangeParam<UploadFile<any>>) => {
        if (info.file.status === 'removed') {
            setFileSelectUpload([]);
            return;
        }

        const file = info.file.originFileObj;

        if (file) {

            if (file.size > MAX_FILE_SIZE) {
                displayErrorMessage(`El archivo ${file.name} supera el tamaño máximo de 2MB.`);
                return;
            }
            const result = await fileToBase64DataUrl(file) as string;
            const base64 = result.split(',')[1];

            const newFile: AttachedFile = {
                base: base64,
                mediaType: file.type,
                name: file.name,
                size: (file.size / 1024 / 1024).toFixed(2),
                uid: info.file.uid,
                documentType: documentTypeSelect,
            };

            setFileSelectUpload([newFile]);
        }
    };

    const handleFileDrop = async (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        const droppedFile = event.dataTransfer.files[0];

        if (!droppedFile) return;

        if (droppedFile.size > MAX_FILE_SIZE) {
            displayErrorMessage(`El archivo ${droppedFile.name} supera el tamaño máximo de 2MB.`);
            return;
        }

        const result = await fileToBase64DataUrl(droppedFile) as string;
        const base64 = result.split(',')[1];

        const newFile: AttachedFile = {
            name: droppedFile.name,
            mediaType: droppedFile.type,
            base: base64,
            uid: `${Date.now()}`,
            documentType: documentTypeSelect,
        };

        setFileSelectUpload([newFile]);
    };

    const draggerProps: UploadProps = {
        name: 'file',
        multiple: false,
        customRequest: () => false,
        onChange: handleFileSelection,
        onDrop: handleFileDrop,
        showUploadList: true,
        maxCount: 1,
    };

    return (
            <Modal
                title={title}
                centered
                open={open}
                width={650}
                onOk={onSubmit}
                onCancel={onClose}
                confirmText={'Enviar'}
                footer
                loadingConfirmButton={loading}
                className="renew-ap-modal-container"
            >
                <>
                    <Form
                        formProps={{
                            form,
                            name: "cancellation-digitial-policy-form",
                            style: { marginBottom: 10, marginTop: 10 },
                        }}
                    >
                        <RowSize rowProps={{ gutter: [15, 15], justify: 'start' }} className="row-insurance-renew-ap" >
                            <ColSize size={100} >
                                <InputForm
                                formProps={{
                                    label: 'Mensaje para la compañia:',
                                    name: 'messageRenew',
                                }}
                                inputTextAreaProps={{
                                    placeholder: 'Ingrese un mensaje',
                                    rows: 4,
                                }}
                                isTextArea
                                />
         
                            </ColSize>
                            <ColSize size={100}>
                            <RowSize rowProps={{ gutter: 0, justify: 'center' }}>
                                <DraggerUploadFile
                                draggerProps={draggerProps}
                                fileList={fileSelectUpload}
                                formatFile={'PDF, JPEG, JPG o PNG'}
                                />
                            </RowSize>
                            </ColSize>
                        </RowSize>
                    </Form>
                </>
            </Modal>
        );
};